<div [formGroup]="parentFormGroup">
  <mat-form-field
    *ngIf="!isDSD; else dsd"
    mat-form-field
    appearance="outline"
    [floatLabel]="'always'"
    class="address-input"
  >
    <input
      matInput
      maxlength="250"
      type="text"
      [id]="id"
      [placeholder]="placeholder"
      [formControlName]="formName"
      attr.aria-labelledby="{{ accessibilityLabel }}"
      (change)="updateSelectedAddress($event)"
      autocomplete="off"
      [required]="required"
    />

    <mat-error id="error-adresse-hors-quebec" *ngIf="addressFormControl.errors?.outsideProvinces">
      {{ 'propriete.creation.erreur-adresse-hors-quebec' | translate }}
    </mat-error>
    <mat-error id="error-adresse-duplique" *ngIf="addressFormControl.errors?.sameAddress">
      {{ 'propriete.creation.erreur-meme-adresse' | translate }}
    </mat-error>
    <mat-error id="error-adresse-invalide" *ngIf="addressFormControl.errors?.invalid">
      {{ 'erreur.adresse-invalide' | translate }}
    </mat-error>
    <mat-error id="error-adresse-requis" *ngIf="addressFormControl.errors?.required">
      {{ 'erreur.champ-obligatoire' | translate }}
    </mat-error>
  </mat-form-field>

  <ng-template #dsd>
    <p #test class="value" aria-hidden="true" [attr.data-value]="textAreaValue"></p>
    <dsd-textarea
      [identifier]="id"
      [name]="id"
      [formControlName]="formName"
      [required]="required"
      class="dsd-textarea-overrides"
      [style.height]="test.scrollHeight + 28 + 'px'"
      rows="1"
      (focusout)="markAsPending()"
      (keydown)="$event.key === 'Enter' ? $event.preventDefault() : undefined"
      (change)="updateSelectedAddress($event)"
      [attr.error]="
        !!(addressFormControl.status !== 'pending' && addressFormControl.touched && addressFormControl.invalid) ||
        undefined
      "
      [class.extra-margin]="
        !!(addressFormControl.status !== 'pending' && addressFormControl.touched && addressFormControl.invalid)
      "
    >
      <span slot="label">{{ label }}</span>
      <span slot="error">
        {{ (addressFormControl.errors?.invalid ? 'erreur.adresse-invalid' : 'erreur.adresse-required') | translate }}
      </span>
      <span slot="content">{{ addressFormControl.value }}</span>
    </dsd-textarea>
  </ng-template>
</div>
